import script from "./DBOptionsLumpSumChoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./DBOptionsLumpSumChoices.vue?vue&type=script&setup=true&lang=ts"

import "./DBOptionsLumpSumChoices.vue?vue&type=style&index=0&id=6b3592f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b3592f2"]])

export default __exports__